/**
 * Offline Indicator Component
 * Shows a persistent banner when the user is offline
 */
import { useOnlineStatus } from '@/hooks/useOnlineStatus';

export function OfflineIndicator(): JSX.Element | null {
  const { isOnline } = useOnlineStatus();

  if (isOnline) {
    return null;
  }

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed left-0 right-0 top-0 z-50 flex items-center justify-center gap-2 bg-warning-light px-4 py-2"
    >
      {/* Offline icon */}
      <svg
        className="h-4 w-4 text-warning"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M18.364 5.636a9 9 0 010 12.728m0 0l-2.829-2.829m2.829 2.829L21 21M15.536 8.464a5 5 0 010 7.072m0 0l-2.829-2.829m-4.243 2.829a4.978 4.978 0 01-1.414-2.83m-1.414 5.658a9 9 0 01-2.167-9.238m7.824 2.167a1 1 0 111.414 1.414m-1.414-1.414L3 3m8.293 8.293l1.414 1.414"
        />
      </svg>
      <span className="text-sm font-medium text-warning">
        You&apos;re offline. Changes will sync when connected.
      </span>
    </div>
  );
}
